import React from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineSwap } from "react-icons/ai";
import { BiSolidTimer } from "react-icons/bi";

import DefaultBaseMenu from "../default/components/DefaultBaseMenu";
const OtherApps = () => {
  const navigate = useNavigate();

  return (
    <div className="mt-3 grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3 lg:gap-8 ">
      <DefaultBaseMenu
        onClick={() => {
          navigate("/admin/shifts");
        }}
        icon={<AiOutlineSwap className="h-16 w-16 fill-white" />}
        text={"Ээлж"}
        className=" bg-gradOrange-0 "
      />
      <DefaultBaseMenu
        onClick={() => {
          navigate("/admin/times");
        }}
        icon={<BiSolidTimer className="h-16 w-16 fill-white" />}
        text={"Завсарлага & Хичээлийн цаг"}
        className=" bg-gradBlue-0 "
      />
      {/* <DefaultBaseMenu text={"Дугуйлан"} className=" bg-gradPurple-0" />
      <DefaultBaseMenu text={"Шалгалт"} className=" bg-gradYellow-0" /> */}
    </div>
  );
};

export default OtherApps;
